var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasSidebar)?_c('aside',{class:_vm.cssClasses},[_c('router-view',{attrs:{"name":"sidebar"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }